import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
   providedIn: "root"
})
export class AdditionalProposalService {

   className = 'AdditionalProposalService';

   constructor(private http: HttpClient) { }

   //!NO se usa
   getAdditionalProposalByProgramJobId(programJobId): Observable<any[]> {
      return this.http.get<any[]>(environment.base_URL + "/additional-proposal/", { params: { programJobId: programJobId } });
   }

   getAdditionalProposalByJobId(jobId, version?) {
      let params: any = {};
      params.jobId = jobId;
      if (version) {
         params.version = version;
      }
      return this.http.get<any[]>(environment.base_URL + "/additional-proposal/", { params });
   }

   removeAdditionalProposalByProgramJobId(programJobId, code): Observable<any[]> {
      let params: any = {};
      params.code = code;
      return this.http.delete<any[]>(environment.base_URL + "/additional-proposal/" + programJobId, { params });
   }

   createAdditionalProposal(AdditionalProposal): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/additional-proposal", AdditionalProposal);
   }

   updateAdditionalProposal(AdditionalProposal): Observable<any[]> {
      return this.http.put<any[]>(environment.base_URL + "/additional-proposal", AdditionalProposal);
   }

   export(AdditionalProposal, jobId): Observable<any[]> {
      let params = {
         jobId
      }
      let options = {
         params,
         responseType: "blob" as 'json'
      }
      return this.http.post<any[]>(environment.base_URL_GAIA + "/additional_proposal/" + AdditionalProposal.idAdditionalProposalPk + "/export", AdditionalProposal, options);
   }
}
